import { Trans } from "react-i18next";

import { PageContent } from "@/components/page";
import { formatCurrency } from "@/lib/utils";
import { useShop } from "@/hooks/use-shop";
import { useUser } from "@/hooks/use-user";

/** What to do at the card terminal while the bank card payment runs. */
export function CardPaymentInstructions({
  price,
  showTitle = true,
}: {
  price: number;
  // the payment flow's header already says "Kérjük fizess bankkártyával!"
  showTitle?: boolean;
}) {
  const { data: shop } = useShop();
  const { data: user } = useUser();
  const websiteUrl = shop.website ?? "";
  const email = shop.email ?? "";

  return (
    <PageContent>
      {showTitle && (
        <div className="text-center my-8">
          <h1 className="text-6xl font-helvetica font-bold text-primary mb-8">
            <Trans>Kérjük fizess bankkártyával!</Trans>
          </h1>
        </div>
      )}

      <div className="flex flex-col items-center justify-center mt-16 mb-16">
        <span className="text-5xl text-primary mb-8">
          <Trans>Fizetendő</Trans>
        </span>
        <span className="text-5xl font-helvetica font-bold text-primary">
          {formatCurrency(price, shop.currencyCode ?? "HUF")}
        </span>
      </div>

      <div className="flex justify-between items-center p-8 mb-12 bg-[#33c0cd]">
        <div className="flex-1">
          <p className="text-white text-2xl leading-10">
            <Trans>
              Kérjük, helyezze be vagy érintse hozzá a bankkártyáját a
              terminálhoz, majd kövesse a képernyőn megjelenő utasításokat!
            </Trans>
          </p>
        </div>
        <div className="w-[200px] h-[160px] ml-10">
          <img
            src="/pin-pad.svg"
            alt="PIN pad"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {shop.canGenerateInvoices && (
        <div className="flex items-center gap-x-3 px-8 mb-8">
          <img src="/arrow-attention.svg" className="size-8" alt="Info" />
          <p className="text-2xl text-primary">
            {user ? (
              <Trans values={{ websiteUrl, email }}>
                Számládat egyszerűen letöltheted a {{ websiteUrl }} oldalról.
              </Trans>
            ) : (
              <Trans values={{ websiteUrl, email }}>
                Számlaigényléshez küldd el a nyugtát és számlázási adataidat a{" "}
                {{ email }} email címre.
              </Trans>
            )}
          </p>
        </div>
      )}

      <div className="flex justify-center mb-8">
        <div className="w-24 h-24">
          <img
            src="/dual-ball.gif"
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </PageContent>
  );
}

export function CardPaymentHelpText() {
  return (
    <Trans>
      Itt látod a fizetendő összeget és a bankkártyás fizetés utasításait. A
      terminál PIN pad segítségével végezheted el a fizetést.
    </Trans>
  );
}
